

function About() {
    return (
        <div className="container text-center mt-4">
            <h1 className="text-center aos-init aos-animate" >About Us</h1>
            <hr />
            <p>My name is Adarsh Siddharth Shankar Mishra from Thane .
                I am pursuing Bsc.IT from University of MUMBAI expecting 2023.I am improving my knowledge and learning some skills.
                My strength is I am hard-work person then self-motivater self- confidence and concentration my career growth.
                My short-term goal is get a good job in reputed company.</p>
            <p>This wesite is made for made for learning pourpose.By using that you can edit  your text.</p>
            <p>Hope you will like that.This is an easy to use online tool for counting words, characters, sentences, paragraphs and pages in real time.</p>
        </div>
    );
}

export default About;


